// extracted by mini-css-extract-plugin
module.exports = {"root":"Grid_root__Ox0D9","item":"Grid_item__3T80J"};